<template>
    <authenticated-layout>
        <v-card class="px-4">
            <div class="grid grid-cols-7 sm:grid-cols-7 gap-2 pt-4">

                <div class="d-flex align-center col-span-4">
                    <v-text-field
                        v-model="form.search"
                        label="Search"
                        placeholder="Type to search..."
                        variant="outlined"
                        density="compact"
                        persistent-placeholder
                        hide-details
                    />
                </div>

                <div class="d-flex align-center col-span-1">
                    <v-btn
                        variant="flat"
                        class="ml-2"
                        size="small"
                        color="blue"
                        @click="filter()"
                    >
                        {{ $t("sharedSearchFilter.Filter") }}
                    </v-btn>
                    <v-btn
                        variant="flat"
                        class="ml-2"
                        size="small"
                        color="grey"
                        @click="resetFilers()"
                    >
                        {{ $t("sharedSearchFilter.Reset") }}
                    </v-btn>
                </div>
            </div>

            <div class="overflow-x-auto mt-4">
                <table class="zebra-table">
                    <tr>
                        <th class="text-left w-10">
                            <input
                                type="checkbox"
                                v-model="selectAll"
                                @change="selectAllItems"
                            />
                        </th>
                        <th class="text-left w-20">
                            id
                        </th>
                        <th class="text-left">
                            Type
                        </th>
                        <th class="text-left">
                            Name
                        </th>
                        <th class="text-left">
                            Email
                        </th>
                        <th class="text-left">
                            Phone
                        </th>
                        <th class="text-left">
                            Address
                        </th>
                        <th class="text-left">
                            State
                        </th>
                        <th class="text-left">
                            Created
                        </th>
                        <th class="text-left">
                            Updated
                        </th>
                        <th class="text-left">
                            Actions
                        </th>
                    </tr>

                    <tr
                        v-for="calculator in calculators.data"
                        :key="`user-${calculator.id}`"
                    >
                        <td>
                            <input
                                type="checkbox"
                                v-model="selectedItems"
                                :value="calculator.id"
                            />
                        </td>
                        <td>{{ calculator.calculator_id }}</td>
                        <td>{{ calculator.type }}</td>
                        <td>{{ calculator.name }}</td>
                        <td>{{ calculator.email }}</td>
                        <td>{{ calculator.phone }}</td>
                        <td>{{ calculator.address }}</td>
                        <td v-html="getState(calculator)"></td>
                        <td>{{ calculator.created_at }}</td>
                        <td>{{ calculator.updated_at }}</td>
                        <td class="text-right px-1">
                            <v-btn
                                size="x-small"
                                variant="flat"
                                color="blue"
                                :href="route('admin-api.details', { offerCalculator: calculator.id })"
                            >
                                Details
                            </v-btn>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="mt-6 pb-6 d-flex align-center">
                <v-select
                    v-model="itemsPerPage"
                    label="Items per page"
                    class="max-w-[150px] mr-5"
                    :items="itemsPerPageOptions"
                    variant="outlined"
                    density="compact"
                    persistent-placeholder
                    hide-details
                />

                <div>
                    <template v-for="(link, k) in calculators.links" :key="k">
                        <v-btn
                            v-if="link.url === null"
                            size="small"
                            variant="flat"
                            class="mr-1"
                        >
                            {{ link.label }}
                        </v-btn>

                        <v-btn
                            v-else
                            :href="link.url"
                            size="small"
                            variant="flat"
                            class="mr-1"
                            :color="link.active ? 'primary' : ''"
                        >
                            {{ link.label }}
                        </v-btn>
                    </template>
                </div>
            </div>
        </v-card>
    </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import pickBy from "lodash/pickBy";

export default {
    components: {
        AuthenticatedLayout,
    },
    props: {
        filters: Object,
        calculators: {
            type: Object,
            required: true,
        },
        pageLimit: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            form: {
                search: this.filters.search,
            },
            selectAll: false,
            selectedItems: [],
            itemsPerPage: this.pageLimit,
            itemsPerPageOptions: [20, 30, 50, 100, 500, 1000],
        };
    },
    watch: {
        itemsPerPage() {
            this.onPageLimitChange();
        },
    },
    mounted() { },
    methods: {
        resetFilers() {
            this.form.search = null;
            this.form.datePeriod = null;

            this.filter();
        },
        filter() {
            this.$inertia.get(this.route('admin-api.index'), pickBy(this.form), {
                preserveState: true,
            });
        },
        selectAllItems() {
            if (this.selectAll) {
                this.selectedItems = this.users.data.map((item) => item.id);
            } else {
                this.selectedItems = [];
            }
        },
        onPageLimitChange() {
            this.$inertia.get(this.route('admin-api.index'), {
                ...pickBy(this.form),
                pageLimit: this.itemsPerPage,
            }, {
                preserveState: true,
            });
        },
        getState(calculator) {
            if (calculator.is_sent) {
                return "<span class='text-gray'>Sent</span>";
            } else if (calculator.is_contacts_filled) {
                return "<span class='text-green'>Contacts Filled<span>";
            } else if (calculator.is_completed) {
                return "<span class='text-blue'>Completed</span>";
            } else if (calculator.is_started) {
                return "<span class='text-bold'>Started</span>";
            } else {
                return "<span class='text-red'>Not Started</span>";
            }
        },
    },
};
</script>

<style scoped>
table {
    width: 100%;
    table-layout: fixed;
    font-size: 12px;
}

.zebra-table tr:nth-child(even) {
    background-color: #f2f2f2;
}

@media screen and (max-width: 1024px) {
    table {
        width: auto;
    }
}

th {
    padding: 10px 0px;
    text-align: left;
    box-sizing: border-box;
    padding-left: 10px;
    border-bottom: 1px solid #aaa;
}

td {
    text-align: left;
    box-sizing: border-box;
    padding: 5px 0px;
    padding-left: 10px;
    border-bottom: 1px solid #ccc;
}
</style>
